import React, { useEffect, useState } from "react";
import { Route, Switch, BrowserRouter, Router, Redirect, useHistory ,useLocation} from "react-router-dom";
import HomePage from "../pages/grocery";
import Profile from "../pages/profile";
import CheckoutPage from "../pages/checkout";
import FavoritesPage from "../pages/favorites";
import SaleCampaignPage from "../pages/saleCampaign";
import OrderPage from "../pages/order";
import Help from "../pages/help";
import GiftCardPage from "../pages/offer";
import OrderRecived from "../pages/order-received";
import CurrentOrderPage from "../pages/current-order";
import AllOrderPage from "../pages/all-orders";
import PaymentScreen from "../pages/payment";
import AboutScreen from "../pages/about";
import ContactScreen from "../pages/contact";
import TermsScreen from "../pages/terms";
import NotificationPage from "../pages/notificationPage"
import Updates from "../pages/updates";
import DeliveryInformationScreen from "../pages/delivery-info";
import SearchedResults from "../pages/searchresults";
import ProductData from "../pages/productinfo";
import SupplierLoginScreen from "../pages/supplier/supplier-login";
import SupplierLoginOnlyScreen from "../pages/supplier/supplier-login-only";
import ResetPasswordOTP from "../components/ResetPasswordOTP";
import supplierDashboardScreen from "../pages/supplier/supplier-dashboard";
import adminAnalytics from "../pages/admin/analytics";
import adminDashboardScreen from "../pages/admin/dashboard";
import adminSuppliersScreen from "../pages/admin/suppliers";
import adminWarehousesShowScreen from "../pages/admin/Warehouse/warehouseShow";
import adminWarehousesCreateOrEditScreen from "../pages/admin/Warehouse/warehouseCreateOrEdit";
import adminSupplierProductsShowScreen from "../pages/admin/SupplierProduct/supplierProductShow";
import adminStocks from "../pages/admin/StockManagement/stocksShow";
import adminWmsWeights from "../pages/admin/WmsWeight/wmsWeightShow";
import adminProducts from "../pages/admin/Products/productList";
import adminCustomers from "../pages/admin/Customer/customers";
import adminUsers from "../pages/admin/usersList";
import adminUserAdd from "../pages/admin/userAdd";
import ProductManagement from "../pages/admin/Products/ProductManagement";
import adminCategoriesScreen from "../pages/admin/categories";
import adminCategorieUpdate from "../pages/admin/categoriesUpdate";
import adminSubCategoriesScreen from "../pages/admin/subCategories";
import adminCategorieAdd from "../pages/admin/categoriesAdd";
import adminSubCategoriesAdd from "../pages/admin/subCategoriesAdd"
import adminSubCategorieUpdate from "../pages/admin/subCategoriesUpdate";
import BulkUploads from "../pages/admin/bulkUploads"
import BulkImageUploads from "../pages/admin/bulkImageUplodes"
import adminBrands from "../pages/admin/brands"
import adminBrandAdd from "../pages/admin/brandAdd"
import adminBrandUpdate from "../pages/admin/brandUpdate"
import OrderList from "../pages/admin/orderList"
import OrderDetails from "../pages/admin/OrderDetail/orderDetails"
import SupplierOrderList from "../pages/supplier/supplier-orderList"
import supplierOrderDetails from "../pages/supplier/supplier-orderDetails"
import NotFound from "../pages/Notfound/index";
import BrandPage from "../pages/brands";
import { connect } from "react-redux";
import { cats } from "../helper/constant";
import BulkExtract from "../pages/admin/bulkExtract";
import UpdateBanner from "../pages/admin/banner_images_update"
import AdminStoreLogo from "../pages/admin/storeLogo"
import ExpressPage from '../pages/express/express';
import ExpressSingleStore from '../pages/express/express-single-store';
import ExpressSearchResult from "../pages/express/express-search-result";
import DeliExpressSettings from "../pages/admin/Setting/deliExpressSettings";
import Order from "../pages/admin/order";
import OrdersV2 from "../pages/admin/OrdersV2";
import DriverList from "../pages/admin/driver";
import WalletList from "../pages/admin/wallet";
import BasketList from "../pages/admin/basket";
import NotificationCenter from "../pages/admin/notificationCenter"
import OrderMap from "../pages/admin/orderMap";
import SlideBanner from "../pages/admin/slide-banner";
import { orderBy } from "lodash";
import RefundPolicies from "../pages/refund-policies";
import Coupon from "../pages/admin/Coupon/coupon";
import adminSupplierAdd from "../pages/admin/supplierAdd";
import HomePageSettings from "../pages/admin/homePageSetting";
import DevSupport from "../pages/admin/DevSupport/devSupport";
import MenuSetting from "../pages/admin/menuSetting"
import adminPromotionCampaigns from '../pages/admin/promotionCampaigns';
import AdminAppVersions from "../pages/admin/appVersions";
import AdminPaymentLink from "../pages/admin/paymentLink";
import AdminMaintenanceMode from '../pages/admin/maintenanceMode';
import SearchConfiguration from '../pages/admin/SearchConfiguration/SearchConfiguration';
import RecentSearchAndPopular from "../pages/admin/RecentSearchAndPopular/RecentSearchAndPopular";
import {initGA,logAddToCart,logAddToWishlist,logPageView,logPurchase,logRemoveFromCart,logRemoveFromWishlist,logSearchQuery,logViewItem,logEventView,logSeenEventView} from "../services/googleAnalytics";
import adminProductsSelection from "../pages/admin/ProductsSelection/ProductsSelection";
import ListProductsSelection from "../pages/admin/ProductsSelection/ListPartnerPage";
import ListPartnerPage from "../pages/admin/ProductsSelection/ListPartnerPage";
import ListLandingPage from "../pages/admin/ProductsSelection/ListLandingPage";
import LandingPartnerPage from "../pages/LandingPartnerPage/LandingPartnerPage";
import storeOngoingSlot from "../pages/admin/merchant/slotSettings/storeOngoingSlot";
import StoreSlotSettingIds from "../pages/admin/merchant/slotSettings/storeSlotSettingIds";
import AssignPicker from "../pages/admin/merchant/slotSettings/AssignPicker";
import AllPartner from "../containers/AllPartner/AllPartner";
import DelipointTiersList from "../pages/admin/Delipoints/DelipointTiersList";
import DelipointSettingsList from "../pages/admin/Delipoints/DelipointSettingsList";
import DelipointPromotionsList from "../pages/admin/Delipoints/DelipointPromotionsList";
import DietaryPreferencesList from "../pages/admin/DietaryPreferences/DietaryPreferencesList";
import DeliveryCompaniesList from "../pages/admin/DeliveryCompanies/DeliveryCompaniesList";
import PickupPointsList from "../pages/admin/PickupPoints/PickupPointsList";
import DeliveryRatesList from "../pages/admin/DeliveryRates/DeliveryRatesList";
import ProductsPage from "../pages/ProductsPage/ProductsPage";
import ImageSearchResults from "../pages/ImageSearch/ImageSearchResults";
import Selections from "../pages/admin/Selections/Selections";
import SelectionForm from "../pages/admin/Selections/SelectionForm";
import AdminOnlyGuard from "../components/AdminOnlyGuard/AdminOnlyGuard";
let admin = localStorage.getItem("admin");
let supplier = localStorage.getItem("supplier");
// import { useHistory } from 'react-router-dom';

// function RouteChangeLogger() {
//   const location = useLocation();
//   useEffect(() => {
//     console.log('Route changed to:', location.search);
//     const page_type = localStorage.getItem("viewProductType")
//     const page_id = localStorage.getItem("viewProductId")
//     const seen_related_products = JSON.parse(localStorage.getItem("seenRelatedIds")) || [];
//     const seen_category_products = JSON.parse(localStorage.getItem("seenProductInCatetory")) || [];
//     const products_list_related  = JSON.parse(localStorage.getItem("viewProductListRelated")) || [];
//     const products_list_category = JSON.parse(localStorage.getItem("viewProductListCategory")) || [];
//     console.log('page_type:', page_type);
//     console.log('page_id:', page_id);
//     console.log('seen_related_products:', seen_related_products);
//     console.log('seen_category_products:', seen_category_products);
//     console.log('products_list_related:', products_list_related);
//     console.log('products_list_category:', products_list_category);
//     if (page_id && (products_list_related.length > 0 || products_list_category.length > 0)) {
//       const product_list = [
//         ...products_list_related,
//         ...products_list_category
//       ];
//       const seen_product_list = [
//         ...seen_related_products,
//         ...seen_category_products
//       ];
//       if (seen_product_list.length > 1) {
//         logEventView(page_type, page_id, product_list.length, seen_product_list);
//       } else {
//         logEventView(page_type, page_id, product_list.length, product_list);
//       }
//     }
//     if (page_id && (seen_related_products.length > 0 || seen_category_products.length > 0)) {
//       logSeenEventView(page_type, page_id, seen_related_products, seen_category_products);
//     }
//     localStorage.removeItem("viewProductId")
//     localStorage.removeItem("seenRelatedIds")
//     localStorage.removeItem("seenProductInCatetory")
//     localStorage.removeItem("viewProductListRelated")
//     localStorage.removeItem("viewProductListCategory")
//   }, [location]);
//   return null;
// }

const Routes = (props,{userAgent}) => {
  const history = useHistory();

  // if(history.location.search !== '') {
  //   let query = history.location.search;
  //   query = query.split('=');
  //   if(query[0].includes('_locale'))
  //     localStorage.setItem('lang', query[1])
  // }

  // const location = useLocation();
  if(window.location.search){
    const searchParams = new URLSearchParams(window.location.search);
    const language = searchParams.get("language");
    if (language && language != null && language != "undefined") {
      localStorage.setItem("lang", language);
      searchParams.delete("language")
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      history.replace(newUrl);
      window.location.reload();
    }
  }
  useEffect(() => {
    if (!history.location.pathname.includes("/product/")) {
      localStorage.removeItem("vector");
    }
    logPageView(history.location.pathname)
  },[history.location.pathname]);

  return (
    <BrowserRouter>
      {/* <RouteChangeLogger/> */}
      <AdminOnlyGuard>
      <Switch>
        <Route key="Home" exact path="/" name="Home" component={() => (admin? <Redirect to="/admin/orders"/>: supplier? <Redirect to="/supplier/orders"/>: <HomePage />)} />
        <Route key="Register" exact path="/register" name="Register" component={() => <HomePage />} />
        <Route key="Profile" exact path="/profile" name="Profile" component={Profile} />
	      <Route key="BrandPage" exact path="/brand/:brandName" name="BrandPage" component={() => <ProductsPage/>}/>
        <Route
          exact
          key="supplierLogin"
          path="/manager/login"
          name="supplierLogin"
          component={SupplierLoginScreen} />
        <Route
          exact
          key="supplierLoginOnly"
          path="/supplier/login"
          name="supplierLoginOnly"
          component={SupplierLoginOnlyScreen} />
        <Route
          exact
          key="supplierResetPassword"
          path="/supplier/reset-password"
          name="supplierResetPassword"
          component={ResetPasswordOTP} />
        <Route
          exact
          key="supplierDashboard"
          path="/supplier/dashboard"
          name="supplierDashboard"
          component={supplierDashboardScreen} />
           ## Supplier dashboard ##


        <Route exact key="orderList" path="/supplier/orders" name="orderList" component={SupplierOrderList} />
        <Route exact key="supplierOrderDetails" path="/supplier/order/details/:id" name="supplierOrderDetails" component={supplierOrderDetails} />


          ## ADMIN dashboard ##
        <Route exact key="adminAnalytics" path="/admin/analytics" name="adminAnalytics" component={adminAnalytics} />
        <Route exact key="supplierDashboard" path="/admin/dashboard" name="supplierDashboard" component={adminDashboardScreen} />
        <Route exact key="suppliersDashboard" path="/admin/suppliers" name="supplierDashboard" component={adminSuppliersScreen} />
        <Route exact key="adminWarehouses" path="/admin/warehouses" name="adminWarehouses" component={adminWarehousesShowScreen} />
        <Route exact key="adminWarehouseAdd"path="/admin/warehouse/add" name="adminWarehouseAdd" component={adminWarehousesCreateOrEditScreen} />
        <Route exact key="adminWarehouseUpdate"path="/admin/warehouse/update/:id" name="adminWarehouseUpdate" component={adminWarehousesCreateOrEditScreen} />
        <Route exact key="adminSupplierProducts" path="/admin/supplierProducts" name="adminSupplierProducts" component={adminSupplierProductsShowScreen} />
        <Route exact key="adminSupplierAdd" path="/admin/supplier/add" name="adminSupplierAdd" component={adminSupplierAdd}/>
        <Route exact key="adminProducts" path="/admin/products" name="adminProducts" component={adminProducts} />
        <Route exact key="adminStocks" path="/admin/stocks" name="adminStocks" component={adminStocks} />
        <Route exact key="adminStocks" path="/supplier/stocks" name="adminStocks" component={adminStocks} />
        <Route exact key="adminWmsWeights" path="/admin/wms-weights" name="adminWmsWeights" component={adminWmsWeights} />
        <Route exact key="adminPromotionCampaigns" path="/admin/promotion-campaigns" name="adminPromotionCampaigns" component={adminPromotionCampaigns} />
        <Route exact key="adminUsers" path="/admin/users" name="adminUser" component={adminUsers} />
        <Route exact key="adminUserAdd" path="/admin/users/add" name="adminUser" component={adminUserAdd} />
        <Route exact key="adminCustomers" path="/admin/customers" name="adminCustomer" component={adminCustomers} />
	      <Route exact key="ProductManagement" path="/admin/product/:type" name="ProductManagement"
	             component={ProductManagement}/>
	      {/*<Route exact key="adminProductUpdate" path="/admin/product/update/:id" name="adminProductUpdate" component={adminProductUpdate} />*/}
        <Route exact key="supplierCategories" path="/admin/categories" name="supplierCategories" component={adminCategoriesScreen} />
        <Route exact key="adminCategorieUpdate" path="/admin/categorie/update" name="adminCategorieUpdate" component={adminCategorieUpdate} />
        <Route exact key="supplierSubCategories" path="/admin/subCategories" name="supplierSubCategories" component={adminSubCategoriesScreen} />
        <Route exact key="adminSubCategorieUpdate" path="/admin/subCategorie/update" name="adminSubCategorieUpdate" component={adminSubCategorieUpdate} />
        <Route exact key="adminCategorieAdd" path="/admin/categorie/add" name="adminCategorieAdd" component={adminCategorieAdd} />
        <Route exact key="adminSubCategoriesAdd" path="/admin/subCategories/add" name="adminSubCategoriesAdd" component={adminSubCategoriesAdd} />
        <Route exact key="adminBrand" path="/admin/brands" name="adminBrand" component={adminBrands} />
        <Route exact key="adminBrandAdd" path="/admin/brand/add" name="adminBrandAdd" component={adminBrandAdd} />
        <Route exact key="adminBrandUpdate" path="/admin/brand/update" name="adminBrandUpdate" component={adminBrandUpdate} />
        <Route exact key="adminBulkUpload" path="/admin/bulkUploads" name="adminBulkUpload" component={BulkUploads} />
        <Route exact key="adminBulkImageUpload" path="/admin/bulkImageUploads" name="adminBulkImageUpload" component={BulkImageUploads} />
        {/* <Route exact key="orderList" path="/admin/orders" name="orderList" component={OrderList} /> */}
	      {/* Old Orders Page - Can be removed after testing */}
	      <Route exact key="order-old" path="/admin/v1/orders" name="order-old" component={Order}/>
	      {/* New Modern Orders Page V2 */}
	      <Route exact key="orders-v2" path="/admin/orders" name="orders-v2" component={OrdersV2}/>
        <Route exact key="adminOrderDetails" path="/admin/order/details/:id" name="adminOrderDetails" component={OrderDetails} />
        <Route exact key="adminBulkExtract" path="/admin/bulkExtract" name="adminBulkExtract" component={BulkExtract} />
        <Route exact key="adminBannerUpdate" path="/admin/banner_update" name="adminBannerUpdate" component={UpdateBanner} />
        <Route exact key="adminStoreLogo" path="/admin/store-logo" name="adminStoreLogo" component={AdminStoreLogo} />
        <Route exact key="deliExpressSettings" path="/admin/deli_express_settings" name="deliExpressSetting" component={DeliExpressSettings} />
        <Route exact key="driverList" path="/admin/drivers" name="driverList" component={DriverList} />
        <Route exact key="walletList" path="/admin/wallets" name="walletList" component={WalletList} />
        <Route exact key="basketList" path="/admin/baskets" name="basketList" component={BasketList} />
        <Route exact key="notificationCenter" path="/admin/notification-center" name="notificationCenter" component={NotificationCenter} />
        <Route exact key="orderMap" path="/admin/order_map" name="orderMap" component={OrderMap} />
        <Route exact key="slideBanner" path="/admin/slide-banner" name="slideBanner" component={SlideBanner} />
        <Route exact key="coupon" path="/admin/coupon" name="coupon" component={Coupon} />
        <Route exact key="adminHomePageSetting" path="/admin/homepagesetting" name="adminHomePageSetting" component={HomePageSettings} />
        <Route exact key="adminMenuSetting" path="/admin/menu" name="adminMenuSetting" component={MenuSetting} />
        <Route exact key="adminMenuCatSetting" path="/admin/menu/:typeid" name="adminMenuCatSetting" component={MenuSetting} />
        <Route exact key="adminPaymentLink" path="/admin/generate-payment-link" name="adminPaymentLink" component={AdminPaymentLink} />
        <Route exact key="adminMaintenanceMode" path="/admin/maintenance/mode" name="adminMaintenanceMode" component={AdminMaintenanceMode} />
        <Route exact key="adminSearchConfiguration" path="/admin/search-configuration" name="adminSearchConfiguration" component={SearchConfiguration} />
        <Route exact key="adminAppVersions" path="/admin/app-versions" name="adminAppVersions" component={AdminAppVersions} />
        <Route exact key="devSupport" path="/admin/dev-support" name="devSupport" component={DevSupport} />
        <Route exact key="adminRecentSearchPopular" path="/admin/recent-search-popular" name="adminRecentSearchPopular" component={RecentSearchAndPopular} />
        {/* merchants */}
        <Route exact key="storeOngoingSlot" path="/admin/store_ongoing_slot" name="storeOngoingSlot" component={storeOngoingSlot} />
        <Route exact key="storeSlotSettingIds" path="/admin/store_slot_settings_ids" name="storeSlotSettingIds" component={StoreSlotSettingIds} />
        <Route exact key="AssignPicker" path="/admin/assign-picker" name="AssignPicker" component={AssignPicker} />
        {/*  */}
        <Route exact key="ListProductsSelection" path="/admin/partner-page/list" name="partnerPage" component={ListPartnerPage} />
        <Route exact key="ListProductsSelection" path="/admin/landing-page/list" name="LandingPage" component={ListLandingPage} />
	      <Route exact key="adminProductsSelection" path="/admin/products-selection/:page/:type"
	             name="adminProductsSelection" component={adminProductsSelection}/>

	      <Route exact key="DelipointPromotionsList" path="/admin/delipoint-promotions" name="adminDelipointPromotions"
	             component={DelipointPromotionsList}/>
	      <Route exact key="DelipointSettingsList" path="/admin/delipoint-settings" name="adminDelipoints"
	             component={DelipointSettingsList}/>
	      <Route exact key="DelipointTiersList" path="/admin/delipoint-tiers" name="adminDelipoints"
	             component={DelipointTiersList}/>
	      <Route exact key="DietaryPreferencesList" path="/admin/dietary_preferences" name="adminProductsSelection"
	             component={DietaryPreferencesList}/>
	      <Route exact key="DietaryPreferencesManage" path="/admin/dietary_preferences/:type"
	             name="adminProductsSelection" component={DietaryPreferencesList}/>
	      <Route exact key="DeliveryCompaniesList" path="/admin/delivery-companies"
	             name="adminDeliveryCompanies" component={DeliveryCompaniesList}/>
	      <Route exact key="PickupPointsList" path="/admin/pickup-points"
	             name="adminPickupPoints" component={PickupPointsList}/>
	      <Route exact key="DeliveryRatesList" path="/admin/delivery-rates"
	             name="adminDeliveryRates" component={DeliveryRatesList}/>
	      <Route exact key="Selections" path="/admin/selections" name="Selections" component={Selections}/>
	      <Route exact key="SelectionCreate" path="/admin/selections/new" name="SelectionCreate" component={SelectionForm}/>
	      <Route exact key="SelectionEdit" path="/admin/selections/:id/edit" name="SelectionEdit" component={SelectionForm}/>
        <Route key="NotFound" exact path="/not-found" component={NotFound} />
        <Route
          key="Search"
          exact
          path="/search/:text"
          name="SearchResults"
          component={() => <ProductsPage/>}/>
        <Route
          exact
          key="Checkout"
          path="/checkout"
          name="Checkout"
          component={CheckoutPage} />

        <Route key="Favorites" exact path="/favorites" component={FavoritesPage}/>
        <Route key="SaleCampaign" exact path="/campaign/:campaignId" component={SaleCampaignPage}/>

        {/*Delishop Express Route*/}
        <Route exact
               key="ExpressPage"
               path="/express"
               name="ExpressPage"
               component={ExpressPage}
        />
        <Route exact
               key="ExpressSearchResult"
               path="/express/search/:any"
               name="ExpressSearchResult"
               component={ExpressSearchResult}
        />
        <Route exact
               key="ExpressSingleStore"
               path="/express/store/:name"
               name="ExpressSingleStore"
               component={ExpressSingleStore}
        />
        {/*End Delishop Express Route*/}

        <Route exact path="/order" name="Order" component={OrderPage} />
        <Route
          exact
          key="CurrentOrderPage"
          path="/ongoing-orders"
          name="CurrentOrderPage"
          component={CurrentOrderPage} />
        <Route key="help" exact path="/help" name="Help" component={Help} />
        <Route key="Offer" exact path="/offer" name="Offer" component={GiftCardPage} />
        <Route
          exact
          key="orderReceived"
          path="/order-received"
          name="orderRecieved"
          component={OrderRecived} />
        <Route
          exact
          key="AllOrderPage"
          path="/all-orders"
          name="AllOrderPage"
          component={AllOrderPage} />
        <Route
          exact
          key="PaymentScreen"
          path="/payments"
          name="PaymentScreen"
          component={PaymentScreen} />
        <Route
          exact
          key="RefundPolicies"
          path="/refund-policies"
          name="RefundPolicies"
          component={RefundPolicies} />
        <Route key="About" exact path="/about" name="AboutScreen" component={AboutScreen} />
        <Route key="Contact" exact path="/contact" component={ContactScreen} />
        <Route key="Terms" exact path="/terms" component={TermsScreen} />
        {/*<Route key="Updates" exact path="/updates" component={Updates} />*/}
        <Route
          exact
          path="/image/search"
          name="ImageSearchResults"
          component={() => <ImageSearchResults />}
        />
        <Route key="Delivery" exact path="/delivery" component={DeliveryInformationScreen} />
        <Route key="AllBrands" exact path="/brands" component={BrandPage} />
        <Route key="AllPartner" exact path="/partner" component={AllPartner} />
	      <Route key="LandingPage" exact path="/page/:slug" component={() => <ProductsPage/>}/>
	      <Route key="PartnerPage" exact path="/partner/:slug" component={() => <ProductsPage/>}/>
        <Route key="Notification" exact path="/notification/:nid" component={NotificationPage} />
        <Route
          exact
          key="Product"
          path="/product/:pid"
          name="ProductPage"
          component={(props) => <ProductData props={props} />}
        />
        <Route
          key="Cat"
          exact
          path="/:catrefid"
          name="SearchResults"
          component={() => <ProductsPage/>}/>
	      <Route
		      key="CatDeepLink"
		      exact
		      path="/category/:catrefid"
		      name="SearchResults"
		      component={() => <ProductsPage/>}/>
        <Route
          key="CatSubCat"
          exact
          path="/:catrefid/:subcatrefid"
          name="SearchResults"
          component={() => <ProductsPage/>}/>
	      <Route
		      key="CatDeepLink"
		      exact
		      path="/category/:catrefid/:subcatrefid"
		      name="SearchResults"
		      component={() => <ProductsPage/>}
	      />
         <Route key="NF" component={NotFound} />
        {/* <Route render={() => <Redirect to={{pathname: "/"}} />} /> */}


      </Switch>
      </AdminOnlyGuard>
    </BrowserRouter>
  );
}

Routes.getInitialProps = async (appContext) => {
  const { req } = appContext.ctx;
  const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;
  return { userAgent };
};
const mapStateToProps = (state) => {
  return {
    cat_refs: state.productReducer.cat_refs
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);
